
// © Microsoft Corporation. All rights reserved.

// TODO: This should be considered for moving it to the Interests experience wrapper, once that
// code arrives, since this is specific to that experience

import { SubnavTabId } from "./SubnavTabId";
import { SubnavTabName } from "./SubnavTabName";

export namespace TabsHelper {
    /**
     * Converts from the tab enum to the tab names
     *
     * @export
     * @param {SubnavTabId} tabId - The tabId being converted
     * @return The tab name
     */
    export function tabIdToTabName(tabId: SubnavTabId): string {
        switch (tabId) {
            case SubnavTabId.Interests:
                return SubnavTabName.Interests;

            case SubnavTabId.MyFeed:
                return SubnavTabName.MyFeed;

            case SubnavTabId.XFeed:
                return SubnavTabName.XFeed;

            default:
                return "";
        }
    }

    /**
     * Converts from the tab name to the tab enum
     *
     * @export
     * @param {string} tabName - The tabName being converted
     * @return The tabId
     */
    export function tabNameToTabId(tabName: string): SubnavTabId {
        switch (tabName) {

            case SubnavTabName.MyFeed:
                return SubnavTabId.MyFeed;

            case SubnavTabName.XFeed:
                return SubnavTabId.XFeed;

            case SubnavTabName.Interests:
                return SubnavTabId.Interests;

            default:
                return SubnavTabId.None;
        }
    }
}